import {
  makeTabTypeFromPlan,
  TProxyTabType,
} from "@/components/newcustomize/utils/makeProxyTabType";
import { PlanType } from "@/types/PlanTypes";

export default function findPlanForType(
  plans: PlanType[],
  planKey: TProxyTabType,
  activeOnly?: boolean
) {
  return plans.find(
    (plan) =>
      makeTabTypeFromPlan(plan) === planKey &&
      (activeOnly ? plan.status === "active" : true)
  );
}
